/**
 * <bk-disclosure target="id"> — wraps one toggle button. Clicking it toggles the `is-open`
 * class on the element with that id and keeps the button's aria-expanded in sync, exactly
 * like the design's mobile "Browse guides and reference" toggle. Escape closes it.
 * With the focus-input attribute, opening moves focus to the panel's first field (header search).
 * Without JS the element stays undefined and CSS shows the list open instead.
 */
class BkDisclosure extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', () => this.toggle());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen) this.toggle(false);
    });
  }

  get panel() {
    return document.getElementById(this.getAttribute('target'));
  }

  get isOpen() {
    return this.button.getAttribute('aria-expanded') === 'true';
  }

  toggle(force) {
    const panel = this.panel;
    if (!panel) return;
    const open = typeof force === 'boolean' ? force : !this.isOpen;
    panel.classList.toggle('is-open', open);
    this.button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && this.hasAttribute('focus-input')) {
      const field = panel.querySelector('input');
      if (field) field.focus();
    }
  }
}

if (!customElements.get('bk-disclosure')) customElements.define('bk-disclosure', BkDisclosure);
